import ws from '@api/webservice'
import config from '@app/config'
import { fetchPages } from '@api/utils'

const api = {
  all: () => fetchPages<SiteResponse>('sites', config.ws.site.all, 'GET'),
  get: (id: string) => ws<SiteResponse>(config.ws.site.get.replace('{id}', id), 'GET'),
}

export default api
